module.exports = __webpack_public_path__ + "media/images/main_slider/Deposito Berbagi Hari-H-d94994389ebad1cc0c55210929c2c245.png";